// ============================================================================
// Sociability Location Pin Icons
// ============================================================================
// These icons are used to indicate accessibility information status in venue cards

export function SociabilityPinIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8 1C5.243 1 3 3.243 3 6c0 3.75 5 9 5 9s5-5.25 5-9c0-2.757-2.243-5-5-5z"
        fill="#EC7E00"
      />
      <circle cx="8" cy="6" r="2" fill="#F9F8FD" />
    </svg>
  );
}

export function SociabilityGreyPinIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8 1C5.243 1 3 3.243 3 6c0 3.75 5 9 5 9s5-5.25 5-9c0-2.757-2.243-5-5-5z"
        fill="#bdbdbd"
      />
      <circle cx="8" cy="6" r="2" fill="#fafafa" />
    </svg>
  );
}

// Duotone info icon used on the "no accessibility data yet" line.
// Fills use currentColor so the surrounding text colour class drives it.
export function AccessibilityInfoIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        opacity="0.2"
        d="M14 8C14 9.18669 13.6481 10.3467 12.9888 11.3334C12.3295 12.3201 11.3925 13.0892 10.2961 13.5433C9.19975 13.9974 7.99335 14.1162 6.82946 13.8847C5.66558 13.6532 4.59648 13.0818 3.75736 12.2426C2.91825 11.4035 2.3468 10.3344 2.11529 9.17054C1.88378 8.00666 2.0026 6.80026 2.45673 5.7039C2.91085 4.60754 3.67989 3.67047 4.66658 3.01118C5.65328 2.35189 6.81331 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
        fill="currentColor"
      />
      <path
        d="M9 11C9 11.1326 8.94732 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.36739 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24022 7.05268 7.36739 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94732 10.7402 9 10.8674 9 11ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8ZM7.75 6C7.89834 6 8.04334 5.95601 8.16668 5.8736C8.29002 5.79119 8.38615 5.67406 8.44291 5.53701C8.49968 5.39997 8.51453 5.24917 8.48559 5.10368C8.45665 4.9582 8.38522 4.82456 8.28033 4.71967C8.17544 4.61478 8.04181 4.54335 7.89632 4.51441C7.75084 4.48547 7.60003 4.50032 7.46299 4.55709C7.32595 4.61386 7.20881 4.70999 7.1264 4.83332C7.04399 4.95666 7 5.10166 7 5.25C7 5.44891 7.07902 5.63968 7.21967 5.78033C7.36032 5.92098 7.55109 6 7.75 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

// Sociability Badge Icon (from VenueCard.tsx)
// Used for displaying last updated status
export function SociabilityBadgeIcon({
  hasData,
  className,
}: {
  hasData: boolean;
  className?: string;
}) {
  if (hasData) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <circle cx="8" cy="8" r="7" stroke="#EC7E00" strokeWidth="1.5" />
        <circle cx="8" cy="8" r="3" fill="#EC7E00" />
        <text
          x="8"
          y="10.5"
          textAnchor="middle"
          fill="#F9F8FD"
          fontFamily="Inter"
          fontSize="8"
          fontWeight="600"
        >
          S
        </text>
      </svg>
    );
  }

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="7" stroke="#A8A7B2" strokeWidth="1.5" />
      <circle cx="8" cy="8" r="3" fill="#A8A7B2" />
      <text
        x="8"
        y="10.5"
        textAnchor="middle"
        fill="#F9F8FD"
        fontFamily="Inter"
        fontSize="8"
        fontWeight="600"
      >
        S
      </text>
    </svg>
  );
}
